import React, { useEffect } from 'react'
import { useContentProjects, useResetContentProjects } from 'components/AuthenticatedLayout/Header/Content'

import Home from './Home'
import Documents from './Documents'
import { useProject } from '../use-projects'

const DetailProject = () => {
  const [{selectedTab}, setContentProjects] = useContentProjects()
  const resetContentProjects = useResetContentProjects()
  const { data } = useProject()

  useEffect(() => {
    setContentProjects(prev => ({...prev, project: data}))
    return () => resetContentProjects()
  }, [data])

  return (
    <>
      {selectedTab === 'home' && <Home />}
      {selectedTab === 'documents' && <Documents />}
    </>
  )
}

export default DetailProject